import * as React from 'react';
import styles from './ErrorIndicator.module.scss';

interface ErrorIndicatorProps {
    error: unknown;
}

export const ErrorIndicator: React.FC<ErrorIndicatorProps> = ({ error }) => {
    return <div className={styles.container}>An error has occurred: {JSON.stringify(error) || '?'}</div>;
};
